import { apiSlice } from '@/api'

export const parkingPlacesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getParkingList: builder.query({
      query: (args) => {
        const { buildingId, page, size, active } = args
        return {
          url: `api/v2/parking/list/${buildingId}`,
          method: 'GET',
          params: { page, size, active }
        }
      },
      providesTags: (result) =>
        result?.data && Array.isArray(result.data)
          ? [
              ...result.data.map(({ id }) => ({ type: 'ParkingList', id })),
              'ParkingList'
            ]
          : ['ParkingList']
      // providesTags: (result) =>
      //   result?.data
      //     ? [
      //         result?.data.map(({ id }) => ({ type: 'ParkingList', id })),
      //         'ParkingList'
      //       ]
      //     : ['ParkingList']
    }),
    getParkingUsers: builder.query({
      query: (args) => {
        const { search } = args
        return {
          url: `api/v2/user`,
          method: 'GET',
          params: { search }
        }
      },
      providesTags: ['ParkingList']
    }),
    addParkingList: builder.mutation({
      query: (body) => ({
        url: 'api/v2/parking/create',
        method: 'POST',
        body
      }),
      invalidatesTags: ['ParkingList']
    }),
    parkingListUpdate: builder.mutation({
      query: (body) => ({
        url: 'api/v2/parking/edit',
        method: 'PUT',
        body
      }),
      invalidatesTags: ['ParkingList']
    }),
    parkingById: builder.query({
      query: (id) => ({
        url: `api/v2/parking/list/${id}`,
        method: 'GET'
      })
    }),
    parkingDelete: builder.mutation({
      query: (id) => ({
        url: `api/v2/parking/delete/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['ParkingList']
    }),
    parkingFreeSpace: builder.mutation({
      query: (data) => ({
        url: '/api/v2/parking/free',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['ParkingList']
    })
  })
})

export const {
  useGetParkingListQuery,
  useGetParkingUsersQuery,
  useLazyGetParkingUsersQuery,
  useParkingListUpdateMutation,
  useParkingByIdQuery,
  useAddParkingListMutation,
  useParkingDeleteMutation,
  useParkingFreeSpaceMutation
} = parkingPlacesApi
